import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';
import { func, arrayOf, string } from 'prop-types';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchTerm: '',
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(e) {
    this.setState({ searchTerm: e.target.value });
  }

  render() {
    const { handleSearchSubmit, terms } = this.props;
    const { searchTerm } = this.state;
    return (
      <Form onSubmit={() => handleSearchSubmit(searchTerm)}>
        <Form.Input
          action={{
            icon: 'search',
          }}
          value={searchTerm}
          onChange={this.handleInputChange}
          placeholder={`${terms[0]}...`}
        />
      </Form>
    );
  }
}

Search.propTypes = {
  handleSearchSubmit: func.isRequired,
  terms: arrayOf(string).isRequired,
};

export default Search;
